import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { useTheme } from '../../theming/useTheme';
import { BaseUnit } from '../../theming/baseUnitDefinition';


const componentConfigThemeKey = 'playIcon';

const playIconStyle = ({ baseUnit, lineColor, fillColor }: PlayIconComponentThemeProps) => StyleSheet.create({
  icon: {
    height: '15%',
    minHeight: '24px',
    width: 'auto',
    position: 'absolute',
    fill: lineColor,
    opacity: 0.75,
    top: `${baseUnit * 0.75}px`,
    left: `${baseUnit * 0.75}px`,
  },
  path: {
    fill: fillColor,
  },
});


export const PlayIconComponent = (props: PlayIconComponentThemeProps) => {
  const style = playIconStyle(props);
  return (
    <svg className={css(style.icon)} viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path className={css(style.path)} d="M18,2A16,16,0,1,0,34,18,16,16,0,0,0,18,2Zm7.58,16.74-5.16,3.07-5.17,3.07A.83.83,0,0,1,14,24.14V11.86a.83.83,0,0,1,1.25-.74l5.17,3.07,5.16,3.07A.86.86,0,0,1,25.58,18.74Z" />
          <path d="M18,2A16,16,0,1,1,2,18,16,16,0,0,1,18,2M14.84,25a.81.81,0,0,0,.41-.12l5.17-3.07,5.16-3.07a.86.86,0,0,0,0-1.48l-5.16-3.07-5.17-3.07a.81.81,0,0,0-.41-.12.85.85,0,0,0-.84.86V24.14a.85.85,0,0,0,.84.86M18,0A18,18,0,1,0,36,18,18,18,0,0,0,18,0ZM16,22.11V13.89l3.4,2L22.92,18,19.4,20.09l-3.4,2Z" />
        </g>
      </g>
    </svg>
  );
};

interface PlayIconComponentThemeProps {
  baseUnit: BaseUnit
  lineColor: string
  fillColor: string
}

const mapThemeProps = (theme: PlayIconComponentThemeProps) => ({
  baseUnit: theme.baseUnit,
  lineColor: theme.lineColor,
  fillColor: theme.fillColor,
});

export const PlayIcon = () => {
  const themeContext = useTheme(mapThemeProps, componentConfigThemeKey);
  return <PlayIconComponent {...themeContext} />;
};
